import page from './page.json';

const exp = {page};

export default exp;